import React from 'react';
import ReactDOM from 'react-dom';
import Root from './_root';

ReactDOM.render(<Root />, document.getElementById('root'));
